// import React, { useState } from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Button,
//   Form,
//   FormGroup,
//   Input,
//   FormText,
//   Spinner,
//   Alert,
// } from "reactstrap";
// import axios from "axios";

// const UploadSignedAgreementModal = ({ isOpen, toggle, organizationId }) => {
//   // ================================
//   // State
//   // ================================
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState(false);

//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     setError("");

//     if (!selected) return;

//     if (selected.type !== "application/pdf") {
//       setError("Only PDF files are allowed.");
//       return;
//     }

//     if (selected.size > 5 * 1024 * 1024) {
//       setError("File size must be less than 5MB.");
//       return;
//     }

//     setFile(selected);
//   };

//   const handleUpload = async () => {
//     if (!file) {
//       setError("Please select a file.");
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const token = localStorage.getItem("token");

//       // ================================
//       // STEP 1: PRESIGN
//       // ================================
// const API_URL =
//   process.env.REACT_APP_API_URL;

//       const presignRes = await axios.post(
//         // `${API_URL}/superadmin/documents/presign`,
//         `${API_URL}/superadmin/organizations/upload-signed-agreement`,
//         {
//           // fileName: file.name,
//           // mimeType: file.type,
//           // fileSize: file.size,
//           organizationId,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const { uploadUrl, documentId } = presignRes.data;
//       console.log(uploadUrl, documentId, "------------------> 11");
//       // ================================
//       // STEP 2: UPLOAD FILE TO S3
//       // ================================
//       const s3Upload = await fetch(uploadUrl, {
//         method: "PUT",
//         headers: {
//           "Content-Type": file.type,
//         },
//         body: file,
//       });

//       if (!s3Upload.ok) {
//         throw new Error("File upload to S3 failed.");
//       }

//       // ================================
//       // STEP 3: COMPLETE UPLOAD
//       // ================================
//       await axios.post(
//         `$${API_URL}/superadmin/documents/${documentId}/complete`,
//         {
//           organizationId,
//           fileSize: file.size,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setSuccess(true);
//       setFile(null);
//     } catch (err) {
//       console.error(err);
//       setError(
//         err.response?.data?.message || err.message || "Something went wrong"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <Modal isOpen={isOpen} toggle={toggle} centered>
//       <ModalHeader toggle={toggle}>Upload Signed Agreement</ModalHeader>

//       <ModalBody>
//         {error && <Alert color="danger">{error}</Alert>}
//         {success && (
//           <Alert color="success">Agreement uploaded successfully.</Alert>
//         )}

//         <Form>
//           <FormGroup>
//             <Input
//               type="file"
//               accept="application/pdf"
//               onChange={handleFileChange}
//               disabled={loading}
//             />
//             <FormText color="muted">Only PDF files allowed (max 5MB)</FormText>
//           </FormGroup>
//         </Form>
//       </ModalBody>

//       <ModalFooter>
//         <Button color="secondary" onClick={toggle} disabled={loading}>
//           Cancel
//         </Button>

//         <Button color="info" onClick={handleUpload} disabled={!file || loading}>
//           {loading ? <Spinner size="sm" /> : "Upload & Submit"}
//         </Button>
//       </ModalFooter>
//     </Modal>
//   );
// };

// export default UploadSignedAgreementModal;
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  FormText,
  Spinner,
  Alert,
} from "reactstrap";
import axios from "axios";
import { showToast } from "../../../utils/toast";

const API_URL = process.env.REACT_APP_API_URL;

const UploadSignedAgreementModal = ({
  isOpen,
  toggle,
  organizationId,
  onSuccess,
}) => {
  /* =======================
     STATE
  ======================= */
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* =======================
     FILE VALIDATION
  ======================= */
  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setError("");

    if (!selected) return;

    if (selected.type !== "application/pdf") {
      setError("Only PDF files are allowed.");
      return;
    }

    if (selected.size > 5 * 1024 * 1024) {
      setError("File size must be less than 5MB.");
      return;
    }

    setFile(selected);
  };

  /* =======================
     UPLOAD HANDLER
  ======================= */
  const handleUpload = async () => {
    if (!file) {
      setError("Please select a file.");
      return;
    }

    if (!organizationId) {
      setError("Organization ID is missing.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const token = sessionStorage.getItem("token") || localStorage.getItem("token");
      const role = sessionStorage.getItem("role") || localStorage.getItem("role");

      if (!token) {
        setError("You are not logged in. Please log in and try again.");
        setLoading(false);
        return;
      }

      if (!["superadmin", "admin"].includes((role || "").toLowerCase())) {
        setError("Only Super Admin or Admin can upload signed agreements.");
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("organizationId", organizationId);
      formData.append("file", file);

      await axios.post(
        `${API_URL}/superadmin/organizations/upload-signed-agreement`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      showToast("Signed agreement uploaded successfully", "success");

      setFile(null);
      toggle();

      // Refresh list / table if callback provided
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.message || "Failed to upload signed agreement"
      );
    } finally {
      setLoading(false);
    }
  };

  /* =======================
     RENDER
  ======================= */
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Upload Signed Agreement</ModalHeader>

      <ModalBody>
        {error && <Alert color="danger">{error}</Alert>}

        <Form>
          <FormGroup>
            <Input
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
              disabled={loading}
            />
            <FormText color="muted">
              Only PDF files allowed (Max size: 5MB)
            </FormText>
          </FormGroup>
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={handleUpload}
          disabled={!file || loading}
        >
          {loading ? <Spinner size="sm" /> : "Upload"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UploadSignedAgreementModal;

